import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-link-bgt-wfs',
    templateUrl: './link-bgt-wfs.component.html',
    styleUrls: ['./link-bgt-wfs.component.scss'],
    imports: [RouterLink]
})
export class LinkBgtWfsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
